// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import DashboardNavigation, { PrimaryRoute, SecondaryRoute } from './DashboardNavigation';

export default DashboardNavigation;
export type { PrimaryRoute, SecondaryRoute };
